// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"3574dd4e","511":"3f2d841e","518":"a17a1239"}[chunkId] + ".chunk.js";
};